import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {ItemsTransactions} from './itemstransactions';
import {TreeNode} from "primeng/api";

@Injectable()
export class ItemsTransactionsService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {


    let currentfilter = JSON.parse(localStorage.getItem('tansactionFilter'));
    if (!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page', page + '');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if (currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('itemstransactions?' + params.toString()).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/itemstransactions/itemstransactions.service.ts